import React, { FC } from 'react'
import { useField } from 'formik'
import clsx from 'clsx'

import { ColorPicker, Tooltip } from '@pepper/ui'

import { ReactComponent as TooltipInfo } from 'assets/images/mini_tooltip.svg'

import { CloseCircleFilled } from '@ant-design/icons'

import styles from './_.module.css'

interface Props {
  name: string
  label?: string
  required?: boolean
  clearKey: string
  miniTooltip?: string
  disabled?: boolean
}

const ColorsPicker: FC<Props> = ({
  name,
  label,
  required,
  clearKey,
  miniTooltip,
  disabled,
}) => {
  const [field, meta, helpers] = useField(name)
  /* eslint-disable no-unused-vars */
  const [, , _clearHelpers] = useField(clearKey)
  const updateValue = (val: string | number, index: number) => {
    const valuesSet = field.value ? [...field.value] : []
    if (index === -1) {
      valuesSet.push(val)
    } else {
      valuesSet[index] = val
    }
    helpers.setValue(valuesSet)
    _clearHelpers.setValue([])
  }
  const deleteColor = (index: number) => {
    const valuesSet = field.value ? [...field.value] : []
    valuesSet.splice(index, 1)
    helpers.setValue(valuesSet)
  }
  const colorSet = field.value ? [...field.value] : []
  return (
    <div
      className={clsx(styles.writerWrap, {
        [styles.optionDisabled]: disabled,
      })}
    >
      <div className={styles.lineWrap}>
        <span className={styles.labelText}>{label}</span>
        {required && <span className={styles.requiredText}>*</span>}
        {miniTooltip && (
          <Tooltip
            placement="top"
            title={() => (
              <div
                dangerouslySetInnerHTML={{
                  __html: miniTooltip,
                }}
              />
            )}
          >
            <TooltipInfo className={styles.tooltipPos} />
          </Tooltip>
        )}
      </div>
      <ColorPicker
        values={colorSet}
        onAddition={updateValue}
        deleteColor={deleteColor}
        disabled={disabled}
      />
      {meta.touched && meta.error ? (
        <div className={styles.error}>
          <CloseCircleFilled className={styles.errorIcon} /> {meta.error}
        </div>
      ) : null}
    </div>
  )
}

export default ColorsPicker
